import {ResponseBaseModel, SystemModulesConfigurationModel} from "../models";
import AlYusrAxiosApiInstance from "../axios/alYusrAxiosApiInstance";
import {AlYuserApiUrls} from "../configuration";

export const getAllSystemLightModule=async ():Promise<ResponseBaseModel< SystemModulesConfigurationModel[]>> => {
    return await AlYusrAxiosApiInstance.get(AlYuserApiUrls.systemConfiguration.getAllSystemLightModule);
}